// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var TableTotalsVisibility;
(function (TableTotalsVisibility) {
    TableTotalsVisibility[TableTotalsVisibility["None"] = 0] = "None";
    TableTotalsVisibility[TableTotalsVisibility["Groups"] = 1] = "Groups";
    TableTotalsVisibility[TableTotalsVisibility["Overall"] = 2] = "Overall";
    TableTotalsVisibility[TableTotalsVisibility["All"] = 3] = "All";
})(TableTotalsVisibility || (TableTotalsVisibility = {}));
